export interface MoveCounterProps {
  moves: number;
  className?: string;
}

export function MoveCounter({ moves, className = "" }: MoveCounterProps) {
  return (
    <div className={`tabular-nums ${className}`} aria-label={`${moves} Züge`}>
      <span className="font-bold text-lg text-white mr-1">Züge</span>
      <span className="font-bold text-lg">{moves}</span>
    </div>
  );
}
